import makeStyles from '@mui/styles/makeStyles'
import { tokens } from './tokens'

// Jednotny vzhled MUI Tabs jako segmented control (sedy track,
// vybrany segment = bila pilulka se stinem). Pouziti:
//   const segTabs = useSegmentedTabsStyles()
//   <Tabs className={segTabs.tabs}> <Tab className={segTabs.tab}/> ...
export const useSegmentedTabsStyles = makeStyles(() => ({
  tabs: {
    minHeight: 'unset',
    backgroundColor: tokens.color.neutral[100],
    borderRadius: '12px',
    padding: '3px',
    width: 'fit-content',
    maxWidth: '100%',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTabs-flexContainer': {
      gap: '2px',
    },
  },
  tab: {
    minHeight: 'unset',
    minWidth: 'unset',
    padding: '7px 14px',
    borderRadius: '9px',
    textTransform: 'none' as const,
    fontSize: '0.8125rem',
    fontWeight: 500,
    lineHeight: 1.2,
    color: tokens.color.neutral[500],
    transition: `background-color ${tokens.transition.fast}, color ${tokens.transition.fast}`,
    '&:hover': {
      color: tokens.color.neutral[900],
      backgroundColor: 'rgba(255, 255, 255, 0.55)',
    },
    '&.Mui-selected': {
      backgroundColor: tokens.color.white,
      color: tokens.color.neutral[900],
      fontWeight: 600,
      boxShadow: '0 1px 3px rgba(8, 38, 69, 0.12), 0 1px 1px rgba(8, 38, 69, 0.06)',
    },
    '&.Mui-disabled': {
      opacity: 0.45,
    },
  },
}))
